import { combineReducers } from 'redux';

import { FETCH_AUDITS_REQUEST } from 'modules/audits/actionTypes';
import { DASHBOARD_SOURCE } from 'modules/audits/constants';
import createHasMoreReducer from 'modules/global/reducers/generic.hasMore';
import createPageReducer from 'modules/global/reducers/generic.page';

import filters from './filters';
import ids from './ids';
import isCreationModalOpen from './isCreationModalOpen';
import links from './links';

/**
 * @typedef {{
 *   filters: import('./filters').AuditDashboardFiltersReducer,
 *   links: import('./links').AuditDashboardLinkReducer,
 *   isCreationModalOpen: boolean,
 *   ids: string[],
 *   hasNext: boolean,
 *   page: import("modules/global/generic.types").Page
 * }} AuditsUIDashboardReducer
 */

const dashboardMatcher = { global: { matcher: ({ meta }) => meta?.source === DASHBOARD_SOURCE } };

export default combineReducers({
  ids,
  links,
  filters,
  isCreationModalOpen,
  page: createPageReducer(FETCH_AUDITS_REQUEST, dashboardMatcher),
  hasNext: createHasMoreReducer(FETCH_AUDITS_REQUEST, dashboardMatcher),
});
